import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { GatewayRepo } from "../../repos/gateway.repo";
import { BsModalService } from "ngx-bootstrap/modal";
import { ManufacturerListService } from "app/services/manufacturers.service";
import { DeviceRepo } from "app/repos";

@Component({
  templateUrl: "./list.component.html",
})
export class GatewayListComponent {
  public searchTerm: string;
  public state = {
    loading: false,
    hasResults: false,
    error: false,
    errorMsg: "",
  };
  public notification = { showLoading: false, message: "", iserror: false };
  public gatewayEntity = null;
  public currentModal: any;

  public manufacturers: any;

  searchTermSeriesItems = [
    { value: "V2", label: "V2" },
    { value: "V3", label: "V3" },
    { value: "V4", label: "V4" },
  ];

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public gatewayRepo: GatewayRepo,
    public modalService: BsModalService,
    public manufacturerListService: ManufacturerListService,
    public deviceRepo: DeviceRepo
  ) {}

  ngOnInit() {
    this.manufacturerListService.getManufacturers().then((res) => {
      this.manufacturers = res.map((manufacturer) => {
        return {
          value: manufacturer.raw.id.toString(),
          display: manufacturer.name,
        };
      });
    });
  }

  hideMessage() {
    this.notification.message = "";
    this.notification.iserror = false;
  }

  clearSearchResults() {
    this.state.error = false;
    this.state.loading = true;
    this.gatewayEntity = null;
  }

  searchGateway(event) {
    event.preventDefault();
    this.clearSearchResults();
    if (this.searchTerm == null || this.searchTerm.length != 6) {
      this.showError("You must provide 6 digit search term.");
    } else {
      this.deviceRepo
        .getBySerialPromise(this.searchTerm)
        .then((deviceEntity: any) => {
          if (!deviceEntity || deviceEntity.length === 0) {
            this.showError("Please enter correct serial number.");
            return Promise.reject("Invalid device");
          }

          return this.gatewayRepo.getBySerialPromise(
            this.searchTerm,
            deviceEntity.series
          );
        })
        .then((gatewayEntity: any) => {
          if (!gatewayEntity || gatewayEntity.success === false) {
            this.showError("Please check the serial number.");
            return Promise.reject("Invalid gateway");
          }

          this.gatewayEntity = gatewayEntity;
          this.state.loading = false;
        })
        .catch(this.handleError.bind(this));
    }
  }

  handleError(error: any) {
    this.showError(
      error.message + ": Please check the gateway id or try again later."
    );
  }

  showError(error: string) {
    this.state.loading = false;
    this.state.errorMsg = error;
    this.state.error = true;
  }
}
